module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_AddUser_16"],"path":[{"$":{"d":"M11.5,7A4.5,4.5,0,1,0,16,11.5,4.5,4.5,0,0,0,11.5,7ZM14,12H12v2H11V12H9V11h2V9h1v2h2ZM3,4A3,3,0,1,1,6,7,3,3,0,0,1,3,4Zm2.5,7.5A6,6,0,0,0,6.63,15H0V11.18C0,9.46,2.68,8,6,8l.62,0A6,6,0,0,0,5.5,11.5Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_AddUser_16.svg
// module id = vXxV
// module chunks = 1